import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { GETROOMTYPE } from 'src/app/components/Shared/Model/GetRoomtype';
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import beautify from 'xml-beautifier';
import { LoginService } from '../Shared/Service/login_service';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { FormControl } from '@angular/forms';
import { Observable, interval } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
export interface User {
  pmsname: string;
  pmscode: any
}
@Component({
  selector: 'app-inventorylog',
  templateUrl: './inventorylog.component.html',
  styleUrls: ['./inventorylog.component.css'],
  providers: [LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class InventorylogComponent implements OnInit {

  myControl = new FormControl('');
  apiresult: any;
  hotellistChannel: any[];
  hotellistproperty: any;
  XMLName: any;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  hotelSearchDataStatus: any;
  heartBeatData: any;
  errorMessage: string;
  productType: any;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) { }
  dropdownSettings = {};
  status: any = [] = [];
  defaultData: any = [] = [];
  PGF: any
  PGT: any
  display: Boolean = false;
  rateCode: string;
  selectedDate: any = new Date();
  todayFuture:any = new Date();
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  futureOneYear:any = new Date();
  futureOneYearDate: any = new Date(this.futureOneYear.setDate(this.futureOneYear.getDate() + 365));
  
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  public SourceBy: any;
  lstgetcmlist: any[];
  lstRoomlist: GETROOMTYPE[];
  lstInventoryCopy: any = [] = [];
  lstInventory: any = [] = [];
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>
  // dataSource: any = [];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['Status', 'Room type', 'Start date', 'End date', 'Inventory', 'Received date', 'Sent date', 'Response date', 'Request', 'Response'];
  selectedChannel: any;
  selectedRoom: any;
  totalcount: any = 0;
  pageSize = 50;
  hotellist: any = [] = [];
  hotellistCopy: any = [] = [];
  allproperty: any[];
  selectedItems: string;
  selected: string;
  Val: string;
  Userid: any = [];
  User: any
  today = new Date();
  filteredOptions: Observable<User[]>;
  /* Search Field */
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  ngOnInit() {
    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    // this.FOOTFALL();
    this.Pmscodevalue = localStorage.getItem("Select");
    console.log(this.Pmscodevalue)
    this.callIDSUsersProperties();
    this.SourceBy = "Pushdate";
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getchannelFXFNStaah()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          this.hotellist = this.apiresult
          console.log('this.hotellist data = ', this.hotellist)
          // this.User.push(this.hotellist)
          this.hotellist = this.apiresult.filter((obj: { pmsname: any; }, pos: any, arr: any[]) => {
            return arr
              .map((mapObj: { pmsname: any; }) => (mapObj.pmsname))
              .indexOf(obj.pmsname) == pos;
          });
          this.User = this.hotellist
          console.log("callIDSUsersProperties data? = " + JSON.stringify(data));
          this.dropdownDeptData = this.hotellist;
          this.hotellistChannel = this.lstgetcmlist;
          this.hotellistproperty = this.hotellist;
          console.log(this.Pmscodevalue)
          // this.getroomlist(this.Pmscodevalue);
          this.isProgressing = false;
        });

  }

  changePropertySearch() {
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.totalcount = 0
        this.Pmscodevalue = this.selectedDeptItems[0].pmscode
        console.log('pms code value = ', this.Pmscodevalue)
        this.getroomlist();
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false

        var result = this.apiresult.filter((obj: { pmscode: MatSelectChange; }) => obj.pmscode == this.Pmscodevalue);
        console.log('filter record = ', result);
        this.lstgetcmlist = result;
        this.selectedChannel = this.lstgetcmlist[0].cmcode;
        // For Online Status
        this.apiCallIdsService
          .readHotelSearch(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHotelSearch =', data)
            this.hotelSearchDataStatus = data[0].recordstatus
            this.productType = data[0].producttype
          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat
            // For blinking the record
            const today = new Date()
            console.log('Today Date = ', today);
            this.currentDateStore = today.toLocaleTimeString('it-IT')
            console.log('Today Date = ', this.currentDateStore);
            this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
            var start = this.storeHeartBeatValue.split(":");
            var end = this.currentDateStore.split(":");
            var startDate = new Date(0, 0, 0, start[0], start[1], 0);
            var endDate = new Date(0, 0, 0, end[0], end[1], 0);
            var diff = endDate.getTime() - startDate.getTime();
            var hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            var minutes = Math.floor(diff / 1000 / 60);
            // console.log('minutes difference',minutes)
            console.log('minutes difference', hours + ":" + minutes)
            if ((hours + ":" + minutes) > "0:30") {
              console.log('blinkOfflineHotel true')
              this.blinkOfflineHotel = true
            } else {
              console.log('blinkOfflineHotel false')
              this.blinkOfflineHotel = false
            }
          });
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
        });

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  GetParseonlyDateTime(d: any) {
    console.log('GetParseonlyDateTime call', d.substring(12))
    return (d.substring(12));
  }

  heartbeatFunction() {
    this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =', data[0])
        this.heartBeatData = data[0].heartBeat
      });
  }

  changeDateOption(data: MatSelectChange) {
    console.log("selected --->" + data);
    this.selectedDate = new Date();
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
  showXml(condition: any, xmltype: any, token: any, sourceTable: any) {
    if (condition == '') {
      this.status = this.LoadXML(xmltype, token, sourceTable);
    } else {
      this.isProgressing = true;
      this.apiCallIdsService.loadXMLData(token)
        .subscribe((res) => {
          console.log('Response =', res.content)
          if (xmltype == 'Response') {
            this.XMLName = "Response XML from Channel"
          } else if (xmltype == "Request") {
            this.XMLName = "Request XML to Channel"
          }
          const xml = beautify(res.content);
          console.log('Beautifier', xml);
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;

        })
    }
  }

  LoadXML(xmltype: any, token: any, sourceTable: any) {
    //alert(token)
    console.log("LoadXML");
    this.isProgressing = true;
    this.apiCallIdsService.getinventoryXML(this.Pmscodevalue, this.selectedChannel, xmltype, token, sourceTable)
      .subscribe(data => {
        if (data.length > 0 && xmltype == "Response") {
          console.log("Response");
          const xml = beautify(data[0].res);
          this.XMLName = "Response XML from Channel"
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }

        else if (data.length > 0 && xmltype == "Request") {
          console.log("Request");
          const xml = beautify(data[0].req);
          console.log(xml);
          this.XMLName = "Request XML to Channel"
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }
        else if (data.length < 1) {
          this.toastr.error('No data Found');
          this.isProgressing = false;
        }
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },
      );
  }
  getchannellist(Pmscodevalue: any) {
    this.isProgressing = true;
    this.apiCallIdsService.getCMLIST(this.Pmscodevalue)
      .subscribe(
        data => {
          if (data.length < 1) {
            this.toastr.error('Property is not activated with Channel manager');
          }
          this.lstgetcmlist = data;
          this.selectedChannel = this.lstgetcmlist[0].cmcode;

          this.getroomlist();
          this.isProgressing = false;
        }

      );
  }
  getroomlist() {
    // this.isProgressing = true;
    console.log(this.Pmscodevalue)
    this.apiCallIdsService.getROOMLIST(this.Pmscodevalue)
      .subscribe(
        data => {
          this.lstRoomlist = data;
          console.log('roomList =', data)
          for (let roomID of this.lstRoomlist) {
            console.log('roomID.id', roomID.id)
            if (roomID.id == 'ALL' || roomID.id == 'all' || roomID.id == 'All') {
              console.log('roomID.name', roomID.name)
              this.selectedRoom = roomID.name;
            }
          }
        }
      )
  }

  GetCommonMethodForLog() {
    this.PGF = "0";
    this.PGT = "50";
    this.GetInventory();
  }

  GetInventory() {
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.apiCallIdsService.getinventorylog(this.Pmscodevalue, this.selectedChannel, this.selectedDate, this.selectedRoom, this.SourceBy, this.PGF, this.PGT)
      .subscribe(
        data => {
          console.log('260 = ', data)
          if (data[0].totalCount >= 1) {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.totalcount = data[0].totalCount;
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          } else {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
        });
  }

  pageEvent(e: any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.GetInventory();
  }
  Search(event: any) {
    console.log('event= ', event)
    this.hotellist = this.hotellistproperty.filter((res: { pmsname: { toString: () => string; }; pmscode: { toString: () => string; } }) => {
      return res.pmsname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmscode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
    });
    if (event == '') {
      this.Val = '';
      this.callIDSUsersProperties();
    }
  }
}
